import React, { useEffect, useState } from 'react';

import { GeneralConstants } from 'app/constants/general-constants';
import { DescriptorData } from 'app/model/crowd/descriptor-data';
import { crowdDescriptorService } from 'app/services/crowd-descriptor.service';
import { DescriptorListGrid } from 'features/crowd/descriptor/descriptor-list-grid';

export const DescriptorList: React.FunctionComponent = () => {
    const [descriptors, setDescriptors] = useState<DescriptorData[]>([]);

    const markReviewed = (entity: DescriptorData) => {
        crowdDescriptorService.update({ ...entity, status: 1 }).subscribe((updated) => {
            setDescriptors(descriptors.map((current) => (current.id === updated.id ? updated : current)));
        });
    };

    useEffect(() => {
        const subscription = crowdDescriptorService
            .listAll({
                pageSize: GeneralConstants.PAGE_SIZE_HUGE,
            })
            .subscribe(setDescriptors);

        return () => subscription.unsubscribe();
    }, []);

    return (
        <DescriptorListGrid
            rows={descriptors}
            markReviewed={markReviewed}
            pagination
            pageSizeOptions={GeneralConstants.PAGE_SIZE_OPTIONS}
            columnVisibilityModel={{
                id: false,
            }}
        />
    );
};
